export default function ContactSection() {
  return (
    <section id="contact" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            内容合作、问题反馈、侵权申诉，欢迎通过以下方式联络
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-[900px] mx-auto">
          {/* Cooperation */}
          <div className="bg-background-50 rounded-xl p-6 md:p-7 text-center group cursor-pointer hover:bg-background-200/30 transition-colors">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mx-auto mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className="ri-briefcase-line text-xl"></i>
            </div>
            <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2">商务合作</h3>
            <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3">
              动漫内容授权、品牌联名推广、广告投放合作，期待与优质合作伙伴共建生态。
            </p>
            <span className="text-sm text-primary-500 font-medium whitespace-nowrap">
              biz@51anime.com
            </span>
          </div>

          {/* Feedback */}
          <div className="bg-background-50 rounded-xl p-6 md:p-7 text-center group cursor-pointer hover:bg-background-200/30 transition-colors">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mx-auto mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
              <i className="ri-feedback-line text-xl"></i>
            </div>
            <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2">问题反馈</h3>
            <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3">
              遇到内容加载、链接失效或功能异常等问题，请随时反馈，运营团队24小时内响应处理。
            </p>
            <span className="text-sm text-primary-500 font-medium whitespace-nowrap">
              feedback@51anime.com
            </span>
          </div>

          {/* Report */}
          <div className="bg-background-50 rounded-xl p-6 md:p-7 text-center group cursor-pointer hover:bg-background-200/30 transition-colors">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mx-auto mb-4 group-hover:bg-secondary-500 group-hover:text-background-50 transition-colors">
              <i className="ri-alert-line text-xl"></i>
            </div>
            <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2">侵权申诉</h3>
            <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3">
              如发现平台内容侵犯您的合法权益，请发送证明材料至申诉邮箱，我们将在48小时内核实处理。
            </p>
            <span className="text-sm text-primary-500 font-medium whitespace-nowrap">
              report@51anime.com
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}